var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login"},[_vm._m(0),_c('div',[_c('p',[_vm._v("Please make sure you are connected to the internet or try again in a few minutes")]),_c('v-progress-linear',{attrs:{"indeterminate":true}}),_c('span',[_vm._v("Attempting to reconnect...")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageHeading"},[_c('h1',{staticStyle:{"color":"red"}},[_vm._v("Connection Error")])])
}]

export { render, staticRenderFns }